
/**
 * External Dependencies
 */
import { get } from 'lodash';


export default (state) => get(state, 'documentHead.title', '');